/******************************************
*  Author : Riccardo Di Dato   
*  Created On : Wed Apr 27 2022
*  File : production.ts
*******************************************/

import { commonConfig } from "./common.js";

export const config = commonConfig;

config.host = "api.fanpage.it";
config.domain = "fanpage.it";
config.mainUrl = "https://www.fanpage.it";
config.secure = true;
config.debug = true;
config.webPush.serviceWorkerHost = "fanpage.it";
config.snhubConfig.domain = "fanpage.it";
config.cookies.cookieDomain = ".fanpage.it";
config.snhubConfig.secure = true;
config.snhubConfig.host = "api.fanpage.it";
config.snhubConfig.enabled = true;


config.ga4.cookieDomain = ".fanpage.it";

config.assetsDistro = "https://d2kujwgapv5t1y.cloudfront.net";

config.loginManager.actual_providers.email.enabled = true;
config.loginManager.actual_providers.email.codeLoginAllowed = true;

//?todo: uncomment to publish newsletters in production
config.support.newsletters = true;
// config.membership = {
//     enable: false
// }

config.membership = {
    enable: true,
    debugMode: false,
    idtoken_name: "pr_idtok",
    landingUrl: "https://www.fanpage.it/abbonamento/aggiornamenti/",
    cardSupport: false,
    giftSupport: false,
    anonBuySupport: true,
    freeTrialSupport: true
}
